export default "__VITE_ASSET__DvgOaPz5__"